var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{staticClass:"view-page-login-info",attrs:{"limit":"small"}},[_c('blank-state',{attrs:{"title":"You don't have access to this page","description":"Contact your administrators to get access to this page."}},[_c('a',{attrs:{"href":"/"}},[_vm._v("Go to dashboard")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59127b54","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageNoAccess.vue
// module id = 350
// module chunks = 0